import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/report/stock';

const getProduct = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/product`, data);
};

const getProductExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/product/export`, data, {
		responseType: 'blob',
	});
};

const getCateGory = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/category`, data);
};

const getGateGoryExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/category/export`, data, {
		responseType: 'blob',
	});
};

const getTransfer = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/transfer`, data);
};

const getTransferExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/transfer/export`, data, {
		responseType: 'blob',
	});
};

const getAdjustment = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/adjustment`, data);
};

const getAdjustmentExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/adjustment/export`, data, {
		responseType: 'blob',
	});
};

const getCargoDamage = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/damage-waste`, data);
};

const getCargoDamageExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/damage-waste/export`, data, {
		responseType: 'blob',
	});
};

const getTake = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/take`, data);
};

const getTakeExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/take/export`, data, {
		responseType: 'blob',
	});
};

export default {
	getProduct,
	getProductExport,
	getCateGory,
	getGateGoryExport,
	getTransfer,
	getTransferExport,
	getAdjustment,
	getAdjustmentExport,
	getCargoDamage,
	getCargoDamageExport,
	getTake,
	getTakeExport,
};
